// theme.js
export const lightTheme = {
    //body: '#E2E2E2',
    body: '#F0F0F7',
    text: '#363537',
    //text: '#000000',
    toggleBorder: '#FFF',
    gradient: 'linear-gradient(#39598A, #79D7ED)',
    secondaryBackgrounColor: "#FFF",
    buttonColor: "#495057",
    newBackgroundColor: "#f5f6f8"
}

export const darkTheme = {
    body: '#000',
    text: '#FAFAFA',
    toggleBorder: '#6B8096',
    gradient: 'linear-gradient(#091236, #1E215D)',
    secondaryBackgrounColor: "#000",
    buttonColor: "#FFF",
    newBackgroundColor: "#000"
}